import { SOFTWARE } from '../constant/actionTypes';
import { dateFormat } from '../helper/StringUtils';
import { httpservice } from '../services';
import { constants } from '../constant/constant';

export const getSoftwareList = (object) => (dispatch) => {
  let query;
  if (object) {
    query = `${constants.API.CLIENT_MODULE_SOFTWARE}/${object.id}`;
  } else {
    query = `${constants.API.SOFTWARE}`;
  }

  dispatch({
    payload: [],
    type: SOFTWARE.GET.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      const { rows = [], count = 0 } = response.data.response;
      const softwareIdArray = [];
      const responseData = rows.map((data) => {
        if (data.clientId) {
          if (softwareIdArray.includes(data.softwareId)) {
            return undefined;
          }

          softwareIdArray.push(data.softwareId);

          return {
            id: data.softwareId,
            submoduleId: data.submoduleId,
            name: data.software.name,
            description: data.software.description,
            guid: data.software.guid,
            created_at: dateFormat(data.software.createdAt),
            created_by: data.software.creator
              ? `${data.software.creator.firstName} ${data.software.creator.lastName}`
              : 'admin',
          };
        }

        return {
          ...data,
          isPublicKey: data.isPublicKey ? 'Available' : 'Not Available',
          created_at: dateFormat(data.createdAt),
          created_by: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          subModuleId: null,
        };
      });

      const dataArray = responseData.filter((element) => typeof element !== 'undefined');

      dispatch({
        payload: {
          data: dataArray,
          count,
        },
        type: SOFTWARE.GET.SUCCESS,
      });

      return {
        data: dataArray,
        count,
      };
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.GET.ERROR,
      });
    });
};

export const doSoftwareCreate = (data) => httpservice()
  .post(`${constants.API.SOFTWARE}`, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const getSoftware = (id) => httpservice()
  .get(`${constants.API.SOFTWARE}/${id}`)
  .then((response) => response.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error.response));

export const doSoftwareUpdate = (data) => httpservice()
  .put(`${constants.API.SOFTWARE}/${data.id}`, data)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doSoftwareDelete = (info) => httpservice()
  .delete(`${constants.API.SOFTWARE}/${info}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const updateSoftwarePublicKey = (updateData) => httpservice()
  .put(`${constants.API.UPLOAD_SOFTWARE_PUBLIC_KEY}`, updateData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const updateSoftwareJWTPublicKey = (updateData) => httpservice()
  .put(`${constants.API.UPLOAD_SOFTWARE_JWT_PUBLIC_KEY}`, updateData)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doUpdateSoftwarePlatforms = (platformInfo) => httpservice()
  .post(`${constants.API.SOFTWARE_PLATFORM}`, { platforms: platformInfo })
  .then((response) => response.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const getSoftwarePlatformsList = (id) => (dispatch) => {
  dispatch({
    payload: [],
    type: SOFTWARE.PLATFORMS.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.SOFTWARE_PLATFORM}/${id}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: SOFTWARE.PLATFORMS.SUCCESS,
      });
      return response.data.response;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.PLATFORMS.ERROR,
      });
    });
};

export const getSoftwareSubmoduleAll = () => (dispatch) => {
  dispatch({
    payload: [],
    type: SOFTWARE.SUBMODULE_LIST.INITIATE,
  });

  return httpservice()
    .get(`${constants.API.SOFTWARE_SUBMODULE_LIST}`)
    .then((response) => {
      dispatch({
        payload: response.data.response,
        type: SOFTWARE.SUBMODULE_LIST.SUCCESS,
      });
      return response.data.response;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.SUBMODULE_LIST.ERROR,
      });
    });
};

export const getSoftwareSubmoduleList = (object) => (dispatch) => {
  let query;

  if (object.clientId) {
    query = `${constants.API.CLIENT}/${object.clientId}/software/${object.softwareId}/submodule`;
  } else {
    query = `${constants.API.SOFTWARE_SUBMODULE}/${object.softwareId}`;
  }

  dispatch({
    payload: { data: [], count: 0 },
    type: SOFTWARE.SUBMODULE_DATA.INITIATE,
  });

  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];

      if (Array.isArray(response.data.response)) {
        rows = response.data.response;
      } else {
        rows = response.data.response.rows;
      }

      const responseData = rows.map((data) => {
        if (data.clientId) {
          return {
            id: data.submoduleId,
            name: data.submodule.name,
            description: data.submodule.description,
            created_at: dateFormat(data.submodule.createdAt),
            created_by: data.submodule.creator
              ? `${data.submodule.creator.firstName} ${data.submodule.creator.lastName}`
              : 'admin',
          };
        }

        return {
          ...data,
          created_at: dateFormat(data.createdAt),
          created_by: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
        };
      });

      dispatch({
        payload: { data: responseData, count: responseData.length },
        type: SOFTWARE.SUBMODULE_DATA.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: SOFTWARE.SUBMODULE_DATA.ERROR,
      });
    });
};
